@if (visible()) {
  <div class="chat-widget">
    @if (open()) {
      <section class="panel" role="dialog" [attr.aria-label]="'chat.visitor.title' | t">
        <div class="panel-head">
          <h2 class="panel-title">{{ 'chat.visitor.title' | t }}</h2>
          <button type="button" class="panel-close" (click)="toggle()" [attr.aria-label]="'chat.close' | t">×</button>
        </div>
        <div class="thread" #thread>
          @if (loading()) {
            <p class="muted">{{ 'common.loading' | t }}</p>
          } @else if (messages().length === 0) {
            <p class="muted">{{ 'chat.visitor.empty' | t }}</p>
          }
          @for (m of messages(); track m.id) {
            <div class="bubble" [class.mine]="m.senderType === 'Visitor'" [class.theirs]="m.senderType === 'Admin'">
              <p>{{ m.body }}</p>
            </div>
          }
        </div>
        @if (error(); as err) {
          <p class="error">{{ err }}</p>
        }
        <form class="composer" (submit)="$event.preventDefault(); send()">
          <input
            type="text"
            [ngModel]="draft()"
            (ngModelChange)="draft.set($event)"
            name="draft"
            [placeholder]="'chat.visitor.placeholder' | t"
            maxlength="4000"
            autocomplete="off"
          />
          <button type="submit" [disabled]="sending() || !draft().trim()">
            {{ 'chat.send' | t }}
          </button>
        </form>
      </section>
    }

    @if (!open()) {
      <button type="button" class="launcher" (click)="toggle()">
        {{ 'chat.visitor.launcher' | t }}
      </button>
    }
  </div>
}
